import React, { FC } from 'react'
import { Article } from 'Models/Article/@types';
import dayjs from 'dayjs'
import clsx from 'clsx';
import VisibilityIcon from '@material-ui/icons/Visibility';
import LockRoundedIcon from '@material-ui/icons/LockRounded';
import { PictureModel } from 'Models/Pictures/Model';
import { Paper, Typography, Box } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenRoundedIcon from '@material-ui/icons/LockOpenRounded';
import SolidSmallIconButton from 'Components/Buttons/SolidSmallIconButton';
import useAsyncTask from 'hooks/useAsyncTask';
import useConfirmationDialog from 'hooks/useConfirmationDialog';
import useToastMessage from 'hooks/useToastMessage';
import { useDispatch } from 'react-redux';
import { OWeeklyTech } from 'Models/WeeklyTech';
import { TDispatch } from 'Typings/Global';
import { Link } from 'react-router-dom';

export interface ArticleCardProps {
    article: Article
}

const ArticleCard: FC<ArticleCardProps> = ({ article }) => {
    const classes = useStyles();
    const dispatch = useDispatch<TDispatch>();
    const deleteTask = useAsyncTask(async () => await dispatch(OWeeklyTech.deleteItem(article.id, {}, undefined, { article })));
    const togglePublishTask = useAsyncTask(async () => await dispatch(OWeeklyTech.postActivity(OWeeklyTech.Activities.TOGGLE_PUBLISH, {}, { id: article?.id, publish: !article?.isPublished })))
    const pic = PictureModel.getPicUrl(article.coverPicture, 'sm');
    const withConfirmationDialog = useConfirmationDialog();
    const loading = togglePublishTask.status === "PROCESSING" || deleteTask.status === "PROCESSING";
    const withToast = useToastMessage();
    const togglePublish = () => { withToast(togglePublishTask.run, { successToastMessage: article.isPublished ? "Unpublished successfully" : "Published successfully" }); }

    const handleDelete = () => {
        withConfirmationDialog(async () => {
            await deleteTask.run();
        }, { agreeText: 'Delete', cancelText: 'Cancel', message: 'Do you want to delete this post?' }, { successToastMessage: "Delete Success" })
    }
    const { views, updated, isPublished, title, slug } = article;
    return (
        <Paper className={classes.root} >
            <Link to={`/dashboard/weekly-tech/${slug}`}>
                <Box className={clsx(classes.badge, classes.viewBadge)} >
                    <VisibilityIcon fontSize={'small'} style={{ marginRight: 4 }} />
                    <Typography variant={'caption'} color={'inherit'} >{views}</Typography>
                </Box>
                {pic ? <img className={classes.pic} src={pic} alt={title} /> : null}
            </Link>
            <Link to={`/dashboard/weekly-tech/${slug}`}>
                <Box className={classes.contentContainer} >
                    <Box className={clsx(classes.badge, classes.dateBadge)} >
                        <Typography variant={'caption'} color={'inherit'} >{dayjs(updated).format('DD MMM, YY')}</Typography>
                    </Box>
                    {!isPublished ? <LockRoundedIcon className={classes.lockIcon} /> : null}
                    <Typography variant={'subtitle2'} >{title}</Typography>
                </Box>
            </Link>
            <Box width={'100%'} p={2} pt={0} textAlign={'right'} >
                <SolidSmallIconButton onClick={togglePublish} color={isPublished ? undefined : 'contrast'} disabled={loading} >
                    {
                        isPublished ?
                            <LockOpenRoundedIcon fontSize={'small'} />
                            :
                            <LockIcon color={'error'} fontSize={'small'} />
                    }
                </SolidSmallIconButton>
                <SolidSmallIconButton disabled={loading} onClick={handleDelete} ><ClearRoundedIcon fontSize={'small'} /></SolidSmallIconButton>
            </Box>
        </Paper>
    )
}

const useStyles = makeStyles((theme) => {
    return (createStyles({
        root: {
            width: 300,
            borderRadius: 8,
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
        },
        contentContainer: {
            padding: 8,
            position: 'relative'
        },
        badge: {
            display: 'flex',
            alignItems: 'center',
            padding: '4px 8px',
            backgroundColor: 'rgba(0, 0, 0, 0.57)',
            color: '#fff',
            borderRadius: 8,
        },
        pic: {
            width: '100%',
            height: 'auto',
        },
        dateBadge: {
            position: 'absolute',
            top: '-30px',
            left: '0px'
        },
        viewBadge: {
            position: 'absolute',
            top: '5px',
            right: '5px'
        },
        lockIcon: {
            color: '#A70D0D',
            position: 'absolute',
            top: '-35px',
            right: '5px',
        }
    }))
})

export default ArticleCard